<!-- Header -->
<h3 mat-dialog-title>
    Attachments
</h3>

<!-- Body -->
<mat-dialog-content class="modal-body" style="min-width: 700px; min-height: 300px;">

    <!-- Attachments Table -->
    <mat-table [dataSource]="tableData">

        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef translate> Name </mat-header-cell>
            <mat-cell *matCellDef="let attachment">
                <a style="cursor: pointer"
                    (click)="downloadAttachment(attachment)">
                    {{attachment.MyFileName}}
                </a>
            </mat-cell>
        </ng-container>

        <!-- Description Column -->
        <ng-container matColumnDef="description">
            <mat-header-cell *matHeaderCellDef translate> Description </mat-header-cell>
            <mat-cell *matCellDef="let attachment">
                {{attachment.Description}}
            </mat-cell>
        </ng-container>

        <!-- Attached Column -->
        <ng-container matColumnDef="attached">
            <mat-header-cell *matHeaderCellDef translate> Attached </mat-header-cell>
            <mat-cell *matCellDef="let attachment">
                {{attachment.DateAttached | date: 'MM/dd/yy'}}
            </mat-cell>
        </ng-container>

        <!-- Visible to Parents/Students Column -->
        <ng-container matColumnDef="visible to parents students">
            <mat-header-cell *matHeaderCellDef translate> Visible to <br /> Parents/Students </mat-header-cell>
            <mat-cell *matCellDef="let attachment">
                {{attachment.AllowParentToView ? 'Y' : 'N'}}
            </mat-cell>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef translate> Actions </mat-header-cell>
            <mat-cell *matCellDef="let attachment">
                <button style="background-color: inherit; border: none;"
                    [matMenuTriggerFor]="actionMenu"
                    [matMenuTriggerData]="{attachment: attachment}"
                    (click)="$event.stopPropagation()">
                    <img src="./assets/images/actions.png" />
                </button>
            </mat-cell>
        </ng-container>

        <!-- Row Definitions -->\
        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columns;" matRipple></mat-row>
    </mat-table>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">
    <tyl-button *ngIf="userCanAdd"
        image="add.png"
        label="Add Attachment"
        (clickEvent)="addAttachment()"></tyl-button>
    <div class="footerRight">
        <tyl-button image="Cancel.png" label="Close" (clickEvent)="close()"></tyl-button>
    </div>
</mat-dialog-actions>

<!-- Action Menu -->
<mat-menu #actionMenu>
    <ng-template matMenuContent let-attachment="attachment">
        <ul class="sis-app-menu-dropdown">
            <li mat-menu-item
                class="sis-app-menu"
                (click)="editAttachment(attachment)"
                translate>
                Edit
            </li>
            <li mat-menu-item
                class="sis-app-menu"
                (click)="deleteAttachment(attachment)"
                translate>
                Delete
            </li>
        </ul>
    </ng-template>
</mat-menu>